import React from 'react';
import {twMerge} from "tailwind-merge";
import type {DeclarationStatus} from "@/src/entities/competition/lib/getDeclarationStatus";

const toneClasses: Record<DeclarationStatus['tone'], string> = {
    open: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
    soon: 'bg-amber-50 text-amber-700 ring-amber-600/20',
    closed: 'bg-neutral-100 text-neutral-600 ring-neutral-500/20',
};

const dotClasses: Record<DeclarationStatus['tone'], string> = {
    open: 'bg-emerald-500',
    soon: 'bg-amber-500',
    closed: 'bg-neutral-400',
};

interface Props {
    status: DeclarationStatus;
    className?: string;
}

function DeclarationStatusBadge({status, className}: Props) {
    return (
        <span
            className={twMerge(
                "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-sm font-semibold ring-1 ring-inset whitespace-nowrap",
                toneClasses[status.tone],
                className
            )}
        >
            <span className={twMerge("h-1.5 w-1.5 rounded-full", dotClasses[status.tone])} />
            {status.label}
        </span>
    );
}

export default DeclarationStatusBadge;
